import { render, staticRenderFns } from "./ReportsComponent.vue?vue&type=template&id=f51050f6&scoped=true&"
import script from "./ReportsComponent.vue?vue&type=script&lang=js&"
export * from "./ReportsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportsComponent.vue?vue&type=style&index=0&id=f51050f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51050f6",
  null
  
)

export default component.exports